{
  "gain": 1,
  "pan": 0,
  "fx_EQ_isActive": false,
  "fx_EQ_low": 0,
  "fx_EQ_mid": 0,
  "fx_EQ_high": 0,
  "send_reverbA": -60,
  "send_reverbB": -60,
  "send_delayA": -60,
  "send_delayB": -60,
  "env_attack": 0,
  "env_decay": 0.4100000000000009,
  "env_sustain": 0,
  "env_release": 2,
  "osc_waveform": "triangle",
  "lpf_cutoff": 1744.9503338234701,
  "lpf_q": 0.7,
  "lfo_rate": 16.655622400000006,
  "lfo_depth": 641.9999999999994,
  "osc_octave": 1,
  "fx_distortion_amount": 1.800000000000001,
  "_metadata": {
    "instrumentType": "synth_wam"
  }
}